import { Link } from "@tanstack/react-router";
import { ROLE_LABEL, Shell } from "@/app/Shell";
import { useNote } from "@/app/kbQueries";
import { RequestError } from "@/app/queries";
import { useMe } from "@/app/session";
import { NotFound, SkeletonRows } from "@/ui/states";
import { NetworkError } from "./route/bits";
import { Markdown } from "./notes/md";

/** Страница заметки базы знаний (SP-KB): заголовок, markdown как в базе,
 *  подпись «из базы знаний» с путём файла, ссылка назад. */
export function NotePage({ slug }: { slug: string }) {
  const me = useMe();
  const note = useNote(slug);
  const user = me.data ? { name: me.data.name, role: ROLE_LABEL[me.data.role] ?? me.data.role } : undefined;

  if (note.status === "pending") {
    return (
      <Shell nav user={user} meta="база знаний">
        <SkeletonRows rows={6} />
      </Shell>
    );
  }
  if (note.status === "error") {
    const notFound = note.error instanceof RequestError && note.error.status === 404;
    return (
      <Shell nav user={user} meta="база знаний">
        {notFound ? <NotFound primary={{ label: "на мой маршрут", href: "/" }} /> : <NetworkError retry={() => void note.refetch()} />}
      </Shell>
    );
  }
  const n = note.data;
  return (
    <Shell nav user={user} meta="база знаний">
      <article className="mx-auto max-w-[760px] px-4 py-7 md:px-6" data-testid="note">
        <div className="mb-2 flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 font-mono text-[11.5px] text-accdim">
          <span>база знаний · заметка менторов</span>
          <button type="button" onClick={() => window.history.back()} className="cursor-pointer border-0 bg-transparent p-0 font-mono text-[11.5px] text-mut hover:text-ink" style={{ color: "var(--mut)" }}>
            ← назад к шагу
          </button>
        </div>
        <h1 className="m-0 mb-5 font-mono text-[26px] font-bold leading-[1.15] tracking-[-.02em] text-ink">{n.title}</h1>
        <Markdown text={n.body} />
        <footer className="mt-8 flex flex-wrap items-baseline justify-between gap-2 border-t border-bd pt-3 font-mono text-[11.5px] text-mut">
          <span>
            из базы знаний · <span className="text-ink2">{n.source_path}</span>
          </span>
          <span>
            обновлено {n.updated_at} ·{" "}
            <Link to="/" className="text-mut underline decoration-bd2 underline-offset-2 hover:text-ink">
              мой маршрут
            </Link>
          </span>
        </footer>
      </article>
    </Shell>
  );
}
